(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["af_all_brands"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBrands(root) {
      var input = root.querySelector('[data-brand-search]');
      if (!input || root.dataset.brandsBound === '1') return;
      root.dataset.brandsBound = '1';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-brand-item]'));
      var empty = root.querySelector('[data-brands-empty]');
      var debug = root.hasAttribute('data-debug');

      function apply() {
        var q = input.value.trim().toLowerCase();
        var shown = 0;
        items.forEach(function (li) {
          var name = li.getAttribute('data-brand-name') || '';
          var match = q === '' || name.indexOf(q) !== -1;
          li.hidden = !match;
          if (match) shown++;
        });
        if (empty) {
          empty.hidden = shown !== 0;
          empty.textContent = shown === 0 ? 'No brands match “' + input.value.trim() + '”.' : '';
        }
        if (debug) console.log('[af_all_brands] query=%o shown=%o/%o', q, shown, items.length);
      }

      input.addEventListener('input', apply);
      apply();
    }

    function initAll() {
      document.querySelectorAll('[data-af-all-brands]').forEach(initBrands);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);

    // Theme editor: re-init when this section is (re)loaded.
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-af-all-brands]');
      if (el) { el.dataset.brandsBound = ''; initBrands(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["af_custom_filter_calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments, ctx = this;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    }

    function money(n) {
      return '$' + Number(n).toFixed(2);
    }

    function formatNominal(nominal) {
      // "20x25x1" -> 20" x 25" x 1"
      return String(nominal).split('x').map(function (p) { return p + '"'; }).join(' x ');
    }

    function gcd(a, b) {
      return b ? gcd(b, a % b) : a;
    }

    // Nearest-1/8" fraction readout for a typed decimal — e.g. 20.375 -> "20 3/8"".
    // Rounds to the nearest eighth (same precision the fields already commit to
    // via step="0.125"), so a value that isn't a clean eighth (a mistyped 1/3,
    // say) still resolves to something rather than showing nothing. Returns ''
    // for a non-positive/invalid value or a whole number with no fraction to add.
    function toFraction(value) {
      if (!(value > 0)) return '';
      var whole = Math.floor(value);
      var eighths = Math.round((value - whole) * 8);
      if (eighths === 8) { whole += 1; eighths = 0; }
      if (eighths === 0) return '';
      var d = gcd(eighths, 8);
      var fracStr = (eighths / d) + '/' + (8 / d);
      return (whole > 0 ? whole + ' ' : '') + fracStr + '"';
    }

    function init(root) {
      var DEBUG = root.hasAttribute('data-cfc-debug');
      var log = DEBUG
        ? function () { console.log.apply(console, ['[af_custom_filter_calculator]'].concat([].slice.call(arguments))); }
        : function () {};

      var configEl = root.querySelector('[data-cfc-config]');
      if (!configEl) { log('no config script tag — aborting'); return; }
      var config;
      try {
        config = JSON.parse(configEl.textContent);
      } catch (e) {
        console.error('[af_custom_filter_calculator] config JSON parse failed', e);
        return;
      }

      var widthInput  = root.querySelector('[data-cfc-field="width"]');
      var heightInput = root.querySelector('[data-cfc-field="height"]');
      var depthSelect = root.querySelector('[data-cfc-field="depth"]');
      var sealedInput = root.querySelector('[data-cfc-field="sealed"]');

      var widthFractionEl  = root.querySelector('[data-cfc-fraction="width"]');
      var heightFractionEl = root.querySelector('[data-cfc-fraction="height"]');

      // Immediate, not debounced with the /quote request — this is a pure
      // client-side readout, no reason to wait 500ms to update it.
      function updateFractionEcho(el, input) {
        if (!el) return;
        var frac = toFraction(parseFloat(input.value));
        el.textContent = frac ? '≈ ' + frac : '';
      }

      var statusEl    = root.querySelector('[data-cfc-status]');
      var noticeEl    = root.querySelector('[data-cfc-stock-notice]');
      var resultsEl   = root.querySelector('[data-cfc-results]');
      var rowsEl      = root.querySelector('[data-cfc-rows]');
      var fitCountEl  = root.querySelector('[data-cfc-fit-count]');

      var requestId = 0;

      function say(message) {
        if (statusEl) statusEl.textContent = message || '';
      }

      // Every configured filter line is always visible — greyed out with no
      // price/button until valid dimensions are entered, rather than hiding
      // the whole list behind a separate "enter your size" prompt. Called on
      // load and whenever the typed dimensions become invalid again.
      function renderPendingRows() {
        rowsEl.innerHTML = '';
        var lines = config.lines || [];
        if (!lines.length) {
          resultsEl.hidden = true;
          return;
        }
        lines.forEach(function (line) {
          rowsEl.appendChild(rowFor(line, { status: 'pending' }, null));
        });
        resultsEl.hidden = false;
      }

      function clearResults() {
        renderPendingRows();
        noticeEl.hidden = true;
        if (fitCountEl) fitCountEl.hidden = true;
      }

      // "N fit W x H x D"" next to the Step 2 header — counts only the
      // buyable results (a real variantGid to add to cart on), not every
      // line that merely priced, so the number matches what's actually
      // clickable below it.
      function renderFitCount(available, inputs) {
        if (!fitCountEl) return;
        var buyable = (available || []).filter(function (r) { return r.variantGid; });
        if (!buyable.length) {
          fitCountEl.hidden = true;
          return;
        }
        var size = inputs.width + ' × ' + inputs.height + ' × ' + inputs.slot + '"';
        fitCountEl.textContent = config.text.fitCount
          .replace('{count}', buyable.length)
          .replace('{size}', size);
        fitCountEl.hidden = false;
      }

      function readInputs() {
        var width = parseFloat(widthInput.value);
        var height = parseFloat(heightInput.value);
        var slot = parseInt(depthSelect.value, 10);
        var sealed = !!(sealedInput && sealedInput.checked);
        // No customer-facing quantity control (see the commented-out field
        // above) — qty:1 here is just the baseline /quote request; each
        // row's actual displayed/charged price is recomputed server-side at
        // its own resolved minimum quantity (result.minQuantity), since a
        // single shared quantity can't represent five different per-line
        // minimums at once.
        return { width: width, height: height, slot: slot, qty: 1, sealed: sealed };
      }

      function valid(inputs) {
        return inputs.width > 0 && inputs.height > 0 && [1, 2, 4].indexOf(inputs.slot) !== -1;
      }

      function renderStockNotice(stockMatches) {
        if (!stockMatches || !stockMatches.length) {
          noticeEl.hidden = true;
          return;
        }
        noticeEl.innerHTML = '';

        var heading = document.createElement('p');
        heading.className = 'af-cfc__notice-heading';
        heading.textContent = config.text.stockHeading;
        noticeEl.appendChild(heading);

        var list = document.createElement('div');
        list.className = 'af-cfc__notice-list';
        stockMatches.forEach(function (match) {
          var row = document.createElement('div');
          row.className = 'af-cfc__notice-row';

          var name = document.createElement('span');
          name.className = 'af-cfc__notice-row-name';
          name.textContent = (match.storeName || match.product) + ' — ' + formatNominal(match.nominal);
          row.appendChild(name);

          var price = document.createElement('span');
          price.className = 'af-cfc__notice-row-price';
          price.textContent = money(match.price);
          row.appendChild(price);

          list.appendChild(row);
        });
        noticeEl.appendChild(list);

        noticeEl.hidden = false;
      }

      // Matches a configured filter_line block to the /quote response: a real
      // price ('priced'), a specific refusal reason from the engine
      // ('unavailable' with a reason quoteAll() already wrote to be shown
      // verbatim to customers), or a generic fallback if the line is
      // missing from both arrays entirely (shouldn't happen, but a
      // misconfigured catalog_id block could hit this).
      function findMatch(catalogId, available, unavailable) {
        for (var i = 0; i < available.length; i++) {
          if (available[i].variantId === catalogId) return { status: 'priced', result: available[i] };
        }
        for (var j = 0; j < unavailable.length; j++) {
          if (unavailable[j].variantId === catalogId) return { status: 'unavailable', reason: unavailable[j].reason };
        }
        return { status: 'unavailable', reason: config.text.unavailable };
      }

      // The engine's refusal reasons are written to be customer-readable
      // already (e.g. "Not made for a 1\" slot."), just swap its internal
      // "slot" wording for whatever this form actually calls the field.
      function friendlyReason(reason) {
        if (!reason) return config.text.unavailable;
        var word = (config.depthLabel || 'Depth').toLowerCase();
        return reason.replace(/\bslot\b/gi, word);
      }

      function appendNote(container, text) {
        var el = document.createElement('p');
        el.className = 'tiny-text af-cfc__row-price-note';
        el.textContent = text;
        container.appendChild(el);
      }

      function rowFor(line, match, inputs) {
        var priced = match.status === 'priced';
        var pending = match.status === 'pending';
        var result = priced ? match.result : null;

        var row = document.createElement('div');
        row.className = 'af-cfc__row';
        if (pending) row.classList.add('af-cfc__row--pending');
        else if (!priced) row.classList.add('af-cfc__row--unavailable');
        if (priced && line.featured) row.classList.add('af-cfc__row--featured');

        var body = document.createElement('div');
        body.className = 'af-cfc__row-body';

        if (priced && line.featured) {
          var badge = document.createElement('span');
          badge.className = 'af-cfc__badge';
          badge.textContent = config.text.featuredBadge;
          body.appendChild(badge);
        }

        // A 'standard' match is a real, already-browsable product — link the
        // name to it. A custom-cut match only exists as a hidden/unlisted
        // ghost variant, nothing worth linking to, so it stays plain text.
        var nameEl;
        if (priced && result.productHandle) {
          nameEl = document.createElement('a');
          nameEl.href = '/products/' + result.productHandle;
          nameEl.className = 'af-cfc__row-name af-cfc__row-name--link';
        } else {
          nameEl = document.createElement('p');
          nameEl.className = 'af-cfc__row-name';
        }
        nameEl.textContent = line.name;
        body.appendChild(nameEl);

        // Pending (no dimensions entered yet) shows the line's own marketing
        // blurb, same as a priced row — only a genuine refusal from the
        // engine (an actual "unavailable" match) replaces it with the reason.
        var descText = !priced && !pending ? friendlyReason(match.reason) : line.description;
        if (descText) {
          var descEl = document.createElement('p');
          descEl.className = 'tiny-text af-cfc__row-desc';
          descEl.textContent = descText;
          body.appendChild(descEl);
        }

        if (priced) {
          var tag = document.createElement('span');
          tag.className = 'af-cfc__tag';
          tag.textContent = result.path === 'standard' ? config.text.stockNote : config.text.customNote;
          body.appendChild(tag);
        }

        row.appendChild(body);

        var priceWrap = document.createElement('div');
        priceWrap.className = 'af-cfc__row-price';

        if (!priced) {
          var dash = document.createElement('p');
          dash.className = 'af-cfc__row-price-value af-cfc__row-price-value--muted';
          dash.textContent = '—';
          priceWrap.appendChild(dash);
        } else {
          var priceEl = document.createElement('p');
          priceEl.className = 'af-cfc__row-price-value';
          priceEl.textContent = money(result.pricePerAssembly);
          priceWrap.appendChild(priceEl);

          if (result.subFilters > 1) appendNote(priceWrap, result.subFilters + ' panels');
          // custom.minimum_quantity (fetched server-side, same metafield that
          // gates the buy-button quantity selector on real product pages) is
          // authoritative when set — it covers both the minimum AND the case
          // size as one number, so it replaces rather than joins the box
          // note below. Only falls back to the pricing engine's own
          // assembliesPerBox (supplier-sheet box quantity, informational
          // only, not enforced) when nothing's been set on the resolved
          // variant/product yet — true today for the custom-cut ghost
          // products until real minimums are confirmed and set on them.
          if (result.minQuantity > 1) {
            appendNote(priceWrap, config.text.minQuantity.replace('{count}', result.minQuantity));
            // result.total was recomputed server-side AT minQuantity (see the
            // worker), so this is the real cost of the minimum order — not
            // pricePerAssembly at some customer-typed qty, since there's no
            // quantity control here to type one into anymore.
            appendNote(priceWrap, config.text.total + ': ' + money(result.total));
          } else if (result.assembliesPerBox > 1) {
            appendNote(priceWrap, config.text.boxOf.replace('{count}', result.assembliesPerBox));
          }
        }
        row.appendChild(priceWrap);

        var actionWrap = document.createElement('div');
        actionWrap.className = 'af-cfc__row-action';

        if (priced && result.variantGid) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'af-button af-button--primary af-button--md';
          var label = document.createElement('span');
          label.className = 'af-button__label';
          label.textContent = config.text.add;
          btn.appendChild(label);
          btn.addEventListener('click', function () {
            addToCart(line, result, inputs, btn, label);
          });
          actionWrap.appendChild(btn);
        } else if (priced) {
          var callLink = document.createElement('a');
          callLink.className = 'af-button af-button--secondary af-button--md';
          callLink.href = 'tel:' + String(config.phone || '').replace(/[^0-9+]/g, '');
          var callLabel = document.createElement('span');
          callLabel.className = 'af-button__label';
          callLabel.textContent = config.text.callToOrder;
          callLink.appendChild(callLabel);
          actionWrap.appendChild(callLink);
        }
        // else: unavailable OR pending — no action at all, empty actionWrap
        // just holds the grid alignment steady with the priced rows above.

        row.appendChild(actionWrap);
        return row;
      }

      function renderResults(available, unavailable, inputs) {
        rowsEl.innerHTML = '';
        var lines = config.lines || [];
        if (!lines.length) {
          resultsEl.hidden = true;
          return;
        }
        // Static, merchant-ordered list — every configured line always shows,
        // greyed out with its specific reason when it doesn't fit this size,
        // rather than only showing whichever lines happened to price.
        lines.forEach(function (line) {
          var match = findMatch(line.catalogId, available, unavailable);
          rowsEl.appendChild(rowFor(line, match, inputs));
        });
        resultsEl.hidden = false;
      }

      function addToCart(line, result, inputs, btn, label) {
        // No customer-facing quantity control (see the commented-out field
        // in Step 1) — always adds exactly the resolved minimum order
        // quantity (custom.minimum_quantity, same metafield/rule
        // af_quantity_rules.liquid uses on real product pages), or 1 when
        // nothing's been set. This is always a valid quantity by
        // construction (a number is always a multiple of itself), so unlike
        // an earlier version of this function there's nothing left to
        // validate/reject here.
        var addQty = result.minQuantity || 1;

        var variantGid = result.variantGid;
        var numericId = variantGid.split('/').pop();
        btn.disabled = true;
        label.textContent = config.text.adding;

        var properties = {
          'Width': inputs.width + '"',
          'Height': inputs.height + '"',
          'Depth': inputs.slot + '"',
          'Sub-filters': String(result.subFilters),
        };
        if (inputs.sealed) properties['Sealed edges'] = 'Yes';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(numericId), quantity: addQty, properties: properties }],
          }),
        })
          .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) {
              // Shopify's own top-level "message" is a generic bucket (almost
              // always literally "Cart Error") — "description" carries the
              // actual reason (e.g. "Cannot find variant"). Surface both so a
              // real failure is diagnosable from the page, not just "Cart Error".
              var reason = res.data && (res.data.description || res.data.message);
              throw new Error(reason || 'Add to cart failed');
            }
            log('added to cart', res.data);
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            var evt = new Event('cart:update', { bubbles: true });
            evt.detail = {
              resource: cart,
              sourceId: root.getAttribute('data-cfc-id') || 'af_custom_filter_calculator',
              data: { source: 'af-custom-filter-calculator', itemCount: cart.item_count },
            };
            document.dispatchEvent(evt);

            label.textContent = config.text.added;
            setTimeout(function () {
              label.textContent = config.text.add;
              btn.disabled = false;
            }, 2000);
          })
          .catch(function (error) {
            log('add to cart failed', error);
            say(error.message || 'Could not add to cart.');
            label.textContent = config.text.add;
            btn.disabled = false;
          });
      }

      function fetchQuote() {
        var inputs = readInputs();
        if (!valid(inputs)) {
          clearResults();
          say('');
          return;
        }

        var myRequestId = ++requestId;
        say(config.text.loading);

        fetch(config.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(inputs),
        })
          .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
          .then(function (res) {
            if (myRequestId !== requestId) return; // superseded by a newer request
            if (!res.ok || !res.data.ok) throw new Error((res.data && res.data.error) || 'Quote failed');

            log('quote', res.data);
            var available = res.data.available || [];
            var unavailable = res.data.unavailable || [];
            // The worker resolves a real variantGid for BOTH custom-cut and
            // exact-stocked ('standard') results, so every buyable line —
            // whichever path priced it — gets a uniform Step 2 row.
            renderResults(available, unavailable, inputs);
            renderFitCount(available, inputs);

            // "Also in stock" is for NEAR (not exact) stocked matches only —
            // an exact match is already its own Step 2 row above, so showing
            // it again here would just duplicate that row.
            var stockMatches = (res.data.stockMatches || []).filter(function (m) { return !m.exactEntry; });
            renderStockNotice(stockMatches);

            say(available.length || stockMatches.length ? '' : config.text.noResults);

            if (DEBUG && unavailable.length) {
              log('unavailable lines', unavailable);
            }
          })
          .catch(function (error) {
            if (myRequestId !== requestId) return;
            log('quote failed', error);
            clearResults();
            say(config.text.error);
          });
      }

      var debounced = debounce(fetchQuote, 500);
      [widthInput, heightInput].forEach(function (el) {
        if (el) el.addEventListener('input', debounced);
      });
      [depthSelect, sealedInput].forEach(function (el) {
        if (el) el.addEventListener('change', debounced);
      });

      if (widthInput) widthInput.addEventListener('input', function () { updateFractionEcho(widthFractionEl, widthInput); });
      if (heightInput) heightInput.addEventListener('input', function () { updateFractionEcho(heightFractionEl, heightInput); });

      clearResults();

      // Prefill from ?w=&h=&d= — the mega menu's Find-your-size chips and W×H×D
      // form land here (snippets/af_mega_menu_cards.liquid). Same explicit-intent
      // logic the old "Try an example" button had: values only ever come from
      // something the visitor clicked, then priced straight away. Depth is only
      // applied if it's one of the select's own options (1/2/4).
      var params = new URLSearchParams(window.location.search);
      var pw = parseFloat(params.get('w'));
      var ph = parseFloat(params.get('h'));
      if (pw > 0 && ph > 0 && widthInput && heightInput) {
        widthInput.value = String(pw);
        heightInput.value = String(ph);
        var pd = params.get('d');
        if (depthSelect && pd && depthSelect.querySelector('option[value="' + pd.replace(/[^0-9.]/g, '') + '"]')) {
          depthSelect.value = pd.replace(/[^0-9.]/g, '');
        }
        updateFractionEcho(widthFractionEl, widthInput);
        updateFractionEcho(heightFractionEl, heightInput);
        fetchQuote();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        log('prefilled from URL', { w: pw, h: ph, d: depthSelect ? depthSelect.value : null });
      }

      log('ready', config);
    }

    document.querySelectorAll('[data-cfc]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["af_filter_finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Normalize a raw size string into the canonical `16" x 25" x 1"` format.
    // Strips trailing codes (e.g. "(01234)"), bracketed notes, and any prefix;
    // unifies the separator and inch marks. Returns '' for anything that isn't
    // a real 2- or 3-axis dimension (e.g. a "Default Title" fallback), so the
    // caller can drop it from the dropdown and omit the result-card line.
    function cleanNum(n) {
      var f = parseFloat(n);
      return isNaN(f) ? n : String(f); // drops trailing ".0", keeps "0.3"
    }

    function normalizeDim(raw) {
      if (!raw) return '';
      var s = String(raw)
        .replace(/\([^)]*\)/g, ' ')   // (01234)
        .replace(/\[[^\]]*\]/g, ' ')  // [notes]
        .replace(/["″'′]/g, ''); // straight/curly inch & prime marks
      var m = s.match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)(?:\s*[x×*]\s*(\d+(?:\.\d+)?))?/i);
      if (!m) return '';
      var parts = [m[1], m[2]];
      if (m[3] != null) parts.push(m[3]);
      return parts.map(function (p) { return cleanNum(p) + '"'; }).join(' x ');
    }

    function init(root) {
      var DEBUG = root.dataset.finderDebug === '1';
      var log = DEBUG
        ? function () { console.log.apply(console, ['[af_filter_finder]'].concat([].slice.call(arguments))); }
        : function () {};

      var matrixEl = root.querySelector('[data-finder-matrix]');
      if (!matrixEl) { log('no matrix script tag found — aborting'); return; }
      var data;
      try {
        data = JSON.parse(matrixEl.textContent);
      } catch (e) {
        console.error('[af_filter_finder] matrix JSON parse failed', e, matrixEl.textContent.slice(0, 200));
        return;
      }

      // Standardize every size up front so dropdown dedup and card display
      // both operate on the canonical format (and unparseable values vanish).
      (data.usages || []).forEach(function (u) {
        (u.variants || []).forEach(function (v) { v.dim = normalizeDim(v.dim); });
      });

      var EMPTY_TEXT = root.dataset.emptyText || '';

      // Sentinel Dimensions option for sizes that aren't in the catalog — never
      // collides with a real dim string, which always comes out of normalizeDim().
      var CUSTOM_SIZE_ENABLED = root.dataset.customSize === '1';
      var CUSTOM_VALUE = '__custom__';
      var CUSTOM_LABEL = root.dataset.customSizeLabel || 'Custom size';
      var CUSTOM_DIM_LOOKUP = {};
      CUSTOM_DIM_LOOKUP[CUSTOM_VALUE] = CUSTOM_LABEL;

      if (DEBUG) {
        log('matrix parsed', data);
        var totalVariants = 0;
        (data.usages || []).forEach(function (u) {
          totalVariants += (u.variants || []).length;
          log('usage', u.handle, '— variants:', (u.variants || []).length);
        });
        log('total variants:', totalVariants);
      }

      var usageSelect = root.querySelector('[data-finder-field="usage"]');
      var mervSelect  = root.querySelector('[data-finder-field="merv"]');
      var dimSelect   = root.querySelector('[data-finder-field="dim"]');
      var form        = root.querySelector('[data-finder-form]');
      var resultsEl   = root.querySelector('[data-finder-results]');
      var emptyEl     = root.querySelector('[data-finder-empty]');
      var customCtaEl = root.querySelector('[data-finder-custom-cta]');

      function variantsForUsage(handle) {
        if (!handle) return [];
        var u = (data.usages || []).find(function (x) { return x.handle === handle; });
        return u ? (u.variants || []) : [];
      }

      function unique(arr) {
        var out = [];
        var seen = Object.create(null);
        for (var i = 0; i < arr.length; i++) {
          if (!seen[arr[i]]) { seen[arr[i]] = true; out.push(arr[i]); }
        }
        return out;
      }

      // v.merv is a list now, not a single string — a product can be valid at
      // more than one level (Air-T-Rex is MERV 8-11 depending on airflow,
      // added 2026-08-06). Flatten every variant's levels into one pool
      // before deduping, so the dropdown offers real individual numbers
      // (8, 9, 10, 11…) rather than one opaque "8-11" bucket a customer
      // searching for a specific level would never think to pick.
      function mervOptionsFor(usage) {
        var variants = variantsForUsage(usage);
        var all = [];
        variants.forEach(function (v) { all = all.concat(v.merv || []); });
        var levels = unique(all.filter(Boolean));
        // Numeric sort — MERV levels are ratings (8, 10, 11, 13…), not alphabetical text.
        levels.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
        return levels;
      }

      function populateMervSelect(usage) {
        var levels = mervOptionsFor(usage);
        var lookup = {};
        levels.forEach(function (lvl) { lookup[lvl] = 'MERV ' + lvl; });
        repopulate(mervSelect, levels, '—', lookup);
      }

      function dimOptionsFor(usage, merv) {
        var variants = variantsForUsage(usage).filter(function (v) { return !merv || (v.merv || []).indexOf(merv) !== -1; });
        return unique(variants.map(function (v) { return v.dim; }).filter(Boolean));
      }

      // Custom size is always offered once a Usage is picked, regardless of what's
      // cataloged — it isn't a real dim, so it's prepended after the catalog lookup
      // rather than folded into dimOptionsFor/unique.
      function populateDimSelect(usage, merv) {
        var opts = dimOptionsFor(usage, merv);
        if (CUSTOM_SIZE_ENABLED) opts = [CUSTOM_VALUE].concat(opts);
        repopulate(dimSelect, opts, '—', CUSTOM_SIZE_ENABLED ? CUSTOM_DIM_LOOKUP : null);
      }

      // Accent color feedback (.af-filter-finder__select--active) once a field
      // actually holds a real value — reused both when the user picks a value
      // directly and when a downstream select's value is invalidated/reset by
      // repopulate() (e.g. MERV clears out when Usage changes underneath it).
      function markActive(select) {
        select.classList.toggle('af-filter-finder__select--active', !!select.value);
      }

      function repopulate(select, options, allOption, labelLookup) {
        var current = select.value;
        select.innerHTML = '';
        if (allOption !== null) {
          var optAll = document.createElement('option');
          optAll.value = '';
          optAll.textContent = allOption;
          select.appendChild(optAll);
        }
        options.forEach(function (val) {
          var o = document.createElement('option');
          o.value = val;
          o.textContent = labelLookup ? (labelLookup[val] || val) : val;
          select.appendChild(o);
        });
        var values = Array.prototype.map.call(select.options, function (o) { return o.value; });
        select.value = values.indexOf(current) !== -1 ? current : '';
        select.disabled = options.length === 0;
        markActive(select);
      }

      function onUsageChange() {
        var u = usageSelect.value;
        log('usage changed →', u);
        markActive(usageSelect);
        populateMervSelect(u);
        populateDimSelect(u, mervSelect.value);
        fireSearch();
      }

      function onMervChange() {
        markActive(mervSelect);
        populateDimSelect(usageSelect.value, mervSelect.value);
        fireSearch();
      }

      function onDimChange() {
        markActive(dimSelect);
        fireSearch();
      }

      function fireSearch() {
        if (!usageSelect.value) { clearResults(); return; }
        if (CUSTOM_SIZE_ENABLED && dimSelect.value === CUSTOM_VALUE) {
          showCustomCta();
          return;
        }
        var matches = matchingVariants();
        log('live filter', { usage: usageSelect.value, merv: mervSelect.value, dim: dimSelect.value, count: matches.length });
        renderResults(matches);
      }

      function showCustomCta() {
        resultsEl.hidden = true;
        resultsEl.innerHTML = '';
        emptyEl.hidden = true;
        if (customCtaEl) customCtaEl.hidden = false;
        log('custom size selected — showing CTA');
      }

      function matchingVariants() {
        return variantsForUsage(usageSelect.value).filter(function (v) {
          return (!mervSelect.value || (v.merv || []).indexOf(mervSelect.value) !== -1)
            && (!dimSelect.value || v.dim === dimSelect.value);
        });
      }

      function clearResults() {
        resultsEl.hidden = true;
        resultsEl.innerHTML = '';
        emptyEl.hidden = true;
        if (customCtaEl) customCtaEl.hidden = true;
      }

      function renderResults(variants) {
        resultsEl.innerHTML = '';
        if (customCtaEl) customCtaEl.hidden = true;
        if (!variants.length) {
          emptyEl.hidden = false;
          resultsEl.hidden = true;
          return;
        }
        emptyEl.hidden = true;
        resultsEl.hidden = false;

        variants.forEach(function (v) {
          var a = document.createElement('a');
          a.className = 'af-filter-finder__result';
          a.href = v.url;

          var img;
          if (v.image) {
            img = document.createElement('img');
            img.className = 'af-filter-finder__result-img';
            img.src = v.image;
            img.alt = '';
            img.loading = 'lazy';
          } else {
            img = document.createElement('div');
            img.className = 'af-filter-finder__result-img';
          }
          a.appendChild(img);

          var meta = document.createElement('div');
          meta.className = 'af-filter-finder__result-meta';

          var title = document.createElement('div');
          title.className = 'af-filter-finder__result-title';
          title.textContent = v.title || '';
          meta.appendChild(title);

          if (v.dim) {
            var dim = document.createElement('div');
            dim.className = 'tiny-text af-filter-finder__result-dim';
            dim.textContent = v.dim;
            meta.appendChild(dim);
          }

          if (v.price) {
            var price = document.createElement('div');
            price.className = 'af-filter-finder__result-price';
            price.innerHTML = v.price;
            meta.appendChild(price);
          }

          a.appendChild(meta);
          resultsEl.appendChild(a);
        });
      }

      usageSelect.addEventListener('change', onUsageChange);
      mervSelect.addEventListener('change', onMervChange);
      dimSelect.addEventListener('change', onDimChange);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        fireSearch();
      });
    }

    document.querySelectorAll('.af-filter-finder[data-finder-id]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
